import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import { Box, Grid, TextField, Button, FormControlLabel, FormGroup, Checkbox, FormControl, Select, MenuItem, InputLabel, Link } from '@mui/material';
import DebitCard from '../DebitCard/DebitCard';
import EmiTable from '../CommonDetails/EmiTable';
import BankDetails from '../ChildComponents/BankDetails';
import EmiCardDetails from '../ChildComponents/EMiDebitCardDetails';
import CardlessEmiDetails from '../ChildComponents/CardlessEmi';
import EmiDebitCardDetails from '../ChildComponents/EMiDebitCardDetails';
import EmiCreditCardDetails from '../ChildComponents/EmiCreditCardDetails';
import Loader from '../../Components/loader';
import ImageComponents from '../../../../Shared/ImageComponents';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 1 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}


 
export default function EmiTabs({apiData}) {
  const [selectBankName, setBankName] = useState('');
  const [bankList, setBankList] = useState(null);
  const [DCbankList, setDCBankList] = useState(null);
  const [selectBankCode, setBankCode] = useState('');
  const [selectDCBankCode, setDCBankCode] = useState('');
  const [value, setValue] = React.useState(0);
  const [codeList , setcodeList] = useState('');
  const [DCcodeList , setDCcodeList] = useState('');
  const [cardlessBankList , setCardlessBankList] = useState(null);
  const [showLoader, setshowLoader] = useState(false);
  const [showBanks, setShowBanks] = useState(true);
  const [showCardForm, setShowCardForm] = useState(false);
  const [showDCCardForm, setShowDCCardForm] = useState(false);
  const [NBerror, setNBerror] = useState(false);
  const [showEmiTable, setShowEmitable] = useState(false);
  const [mode , setMode] = useState('');
  const [bankId , setBankId] = useState('');
  const [selectEmiCode, setSelectEmiCode] = useState('');
  const [processingFees, setProcessingFees] = useState('');
  const [orderedModes, setOrderedModes] = useState([]);

  const handleBankCodeSelection = (bankCode) => {
    setSelectEmiCode(bankCode);
  };

 
  let secret;
  const cardlessMode = 'EMI';
     useEffect(() => {
        if (apiData) {
           
            secret = apiData.secret;
            const payModesToPass =  apiData.beans.payModes;
            const supported = ['EMI', 'EMI_DC', 'EMI_CARDLESS'];
            const defaultIndex = (base) => (base === 'EMI' ? 0 : base === 'EMI_DC' ? 1 : 2);
            const parsedModes = (payModesToPass || [])
              .map(method => {
                if (!method || !method.code) return null;
                const parts = String(method.code).split('-');
                const base = parts[0];
                if (!supported.includes(base)) return null;
                const idxStr = parts[1];
                const idxNum = idxStr !== undefined && !Number.isNaN(parseInt(idxStr, 10)) ? parseInt(idxStr, 10) : defaultIndex(base);
                return { base, index: idxNum, method };
              })
              .filter(Boolean)
              .sort((a, b) => a.index - b.index);
            // Derive preferred order from backend property like "emi:emi_dc,emi_cardless"
            let finalOrderBases = parsedModes.map(m => m.base);
            const preferenceCandidates = [
              apiData && apiData.subpaymodesOrder,
              apiData && apiData.beans && apiData.beans.subpaymodesOrder
            ];
            const prefRaw = preferenceCandidates.find(v => typeof v === 'string' && v.toUpperCase().startsWith('EMI:'));
            if (prefRaw) {
              try {
                const afterColon = prefRaw.split(':')[1] || '';
                const preferList = afterColon.split(',').map(s => String(s || '').trim().toUpperCase()).filter(Boolean);
                const present = new Set(finalOrderBases);
                const orderedFirst = preferList.filter(b => present.has(b));
                const remaining = finalOrderBases.filter(b => !orderedFirst.includes(b));
                finalOrderBases = [...orderedFirst, ...remaining];
              } catch (e) {
                // ignore parse errors; keep default
              }
            }
            setOrderedModes(finalOrderBases);
            const subPayMode = parsedModes.find(m => m.base === 'EMI')?.method;
            const subPayModeDC = parsedModes.find(m => m.base === 'EMI_DC')?.method;
            const subPayModeCardless = parsedModes.find(m => m.base === 'EMI_CARDLESS')?.method;
            const EMIBanks = subPayMode ? subPayMode.subPayModes : null;
            const DCBanks = subPayModeDC ? subPayModeDC.subPayModes : null;
            const cardLess = subPayModeCardless ? subPayModeCardless.subPayModes : null;
            setBankList(EMIBanks);
            setDCBankList(DCBanks);
            setCardlessBankList(cardLess);
            var bankcodes = [];
            var DCbankcodes = [];
            var cardlessCode = [];
            if(EMIBanks){
            EMIBanks.forEach(function(item) {
            bankcodes.push(item.code);
            });
		setcodeList(bankcodes);
	  }
	  if(DCBanks){
            DCBanks.forEach(function(item) {
            DCbankcodes.push(item.code);
            });
		setDCcodeList(DCbankcodes);
	  }
	  if(cardLess){
            cardLess.forEach(function(item) {
            cardlessCode.push(item.code);
            });
            // Reorder cardless using ONLY subsubpaymodesOrder like "EMI_CARDLESS:241,239"
            try {
              const prefSources = [
                typeof (apiData && apiData.subsubpaymodesOrder) === 'string' && apiData.subsubpaymodesOrder,
                typeof (apiData && apiData.beans && apiData.beans.subsubpaymodesOrder) === 'string' && apiData.beans.subsubpaymodesOrder
              ].filter(Boolean);
              let preferredKeys = null;
              for (const src of prefSources) {
                if (typeof src === 'string') {
                  const m = src.match(/(EMI[_\s-]?CARDLESS|EMICARDLESS)\s*:\s*([0-9,\s]+)/i);
                  if (m && m[2]) {
                    preferredKeys = m[2].split(',').map(s => s.trim()).filter(Boolean);
                    break;
                  }
                }
              }
              if (preferredKeys && preferredKeys.length > 0) {
                const seen = new Set();
                const ordered = [];
                preferredKeys.forEach(k => {
                  if (cardlessCode.includes(k) && !seen.has(k)) {
                    ordered.push(k);
                    seen.add(k);
                  }
                });
                const remaining = cardlessCode.filter(c => !seen.has(c));
                cardlessCode = [...ordered, ...remaining];
              }
            } catch (e) {}
            setCardlessBankList(cardlessCode);
	  }
	
       }
    }, [apiData]); 
     
     useEffect(() => {
     if(selectBankCode>0){
     setNBerror(false);
     setShowEmitable(true);
     setMode('EMI');
  }
      
    }, [selectBankCode]); 
    
    useEffect(() => {
     if(selectDCBankCode>0){
     setNBerror(false);
     setShowEmitable(true);
     setMode('EMI_DC');
  }
      
    }, [selectDCBankCode]); 
   
  const EMIhandleChange =  (event) => {
  setSelectEmiCode('');
  const selectedBankCode = event.target.value;
  setBankCode(selectedBankCode); 
  setShowEmitable(true);
  setMode('EMI');

 };
 
 const handleCloseDialog = () => {
     setMode('EMI');
     setShowBanks(true);  
     setShowEmitable(true);
     setShowCardForm(false);
  };

   const handleDCCloseDialog = () => {
     setMode('EMI_DC');
     setShowBanks(true);  
     setShowEmitable(true);
     setShowDCCardForm(false);
  };

  
  
  const DCEMIhandleChange = (event) => {
  setSelectEmiCode('');
  const selectedBankCode = event.target.value;
  setDCBankCode(selectedBankCode); 
  setShowEmitable(true);
  setMode('EMI_DC');
  };
  

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
 
 const handleBankSelect = async () => {
   if(selectBankCode>0 && selectEmiCode !== ''){
   setShowBanks(false);  
   setShowEmitable(false);
   setShowCardForm(true);
   setMode('EMI');
   
   }else{
   setNBerror(true);
   }
 
 }
 
  const handleDCBankSelect = async () => {
   if(selectDCBankCode>0 && selectEmiCode !== ''){
   setShowBanks(false);  
   setShowEmitable(false);
   setShowDCCardForm(true);
   setMode('EMI');
  
   }else{
   setNBerror(true);
   }
 
 }
 
  const handleTabChange = async () => {
   setShowBanks(true);  
   setShowEmitable(false);
   setShowCardForm(false);
   setShowDCCardForm(false);
   setBankCode('');
   setDCBankCode('');
 
 }

  const handleSelectChange = (event) => {
    setBankName(event.target.value);
  };

  return (
    <>

   {showLoader && <Loader show={true} textToShow="Please wait while your transaction is being processed"/>}

    <div className='card-details'>
      <div className="card-detail-form">
        <h5>Select an option</h5>
        <Box sx={{ width: '100%' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={value} className="tab-header" variant="scrollable" onChange={handleChange} aria-label="scrollable auto tabs example"
              TabIndicatorProps={{
                style: { display: 'none', position: 'unset' }
              }}>

              {orderedModes.map((base, idx) => {
                if (base === 'EMI') {
                  return <Tab key={base} label="Credit Card" {...a11yProps(idx)} onClick={handleTabChange}/>;
                }
                if (base === 'EMI_DC') {
                  return <Tab key={base} label="Debit Card" {...a11yProps(idx)} onClick={handleTabChange} />;
                }
                if (base === 'EMI_CARDLESS') {
                  return <Tab key={base} label="Cardless EMI" {...a11yProps(idx)} onClick={handleTabChange} />;
                }
                return null;
              })}
            </Tabs>
          </Box>
          {orderedModes.map((base, idx) => {
            if (base === 'EMI') {
              return (
                <CustomTabPanel key={base} value={value} index={idx}>
                 {showBanks && <div> <div className='card-info'>
                    <ul>
 
                       {codeList && codeList.includes("21") && (
                 <li className={selectBankCode === '21' ? 'active' : ''} onClick={() => setBankCode('21')}>
                        <Link>
                          <img src="./images/hdfc.svg" alt="hdfc" /> <span>HDFC</span>
                        </Link>
                      </li>
                      )}
                       {codeList && codeList.includes("22") && (
                 <li className={selectBankCode === '22' ? 'active' : ''} onClick={() => setBankCode('22')}>
 
                        <Link>
                          <img src="./images/icici.svg" alt="icici" /> <span>ICICI</span>
                        </Link>
                      </li>
                      )}
                       {codeList && codeList.includes("48") && (
                 <li className={selectBankCode === '48' ? 'active' : ''} onClick={() => setBankCode('48')}>
 
                        <Link>
                          <img src="./images/sbi.svg" alt="SBi" /> <span>SBI</span>
                        </Link>
                      </li>
                      )}
                       {codeList && codeList.includes("32") && (
                 <li className={selectBankCode === '32' ? 'active' : ''} onClick={() => setBankCode('32')}>
 
                        <Link>
                          <img src="./images/kotak_mahindra.svg" alt="Kotak Mahindra" /> <span>Kotak Mahindra</span>
                        </Link>
                      </li>
                      )}
                       {codeList && codeList.includes("39") && (
                 <li className={selectBankCode === '39' ? 'active' : ''} onClick={() => setBankCode('39')}>
 
                        <Link>
                          <img src="./images/PNB.svg" alt="PNB" /> <span>Punjab National Bank</span>
                        </Link>
                      </li>
                      )}
                       {codeList && codeList.includes("6") && (
                 <li className={selectBankCode === '6' ? 'active' : ''} onClick={() => setBankCode('6')}>
 
                        <Link>
                          <img src="./images/BOB.svg" alt="hdfc" /> <span>Bank of Baroda</span>
                        </Link>
                      </li>
                      )}
                    </ul>
                  </div>
                  <Grid container spacing={3}>
                    <Grid item md={12} xs={12} >
                      <FormControl fullWidth className='form-control'>
                        <InputLabel id="demo-simple-select-label">Select another bank</InputLabel>
                         <Select
          			 labelId="demo-simple-select-label"
          			 id="demo-simple-select"
          			 value={selectBankCode}
          			 label="Bank Name"
          			 onChange={EMIhandleChange}
          			 >
                          {bankList && bankList.map((bank, index) => (
                        <MenuItem key={index} value={bank.code}>
                        {bank.name}
                         </MenuItem>
                         ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    {showEmiTable &&  <EmiTable  amountToBePaid={apiData.amount} displayOrderNo = {apiData.displayOrderNo}  mode = {mode} bankId = {selectBankCode}           			   onBankCodeSelect={handleBankCodeSelection} selectEmiCode = {selectEmiCode} onProcessingFees={setProcessingFees} />}
              {NBerror && (
        <p style={{ color: 'red', paddingTop: '10px', marginLeft: '27px' }}>
          Please select valid bank and tenure!
        </p>
      )}		
                    <Grid item md={12} xs={12}>
                      <Button variant="outlined" size="large" className='pay-now-btn' onClick={handleBankSelect}>
                        Continue
                      </Button>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    {processingFees && processingFees.trim() !== '' && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                              <span>
                                <ImageComponents name={"notesIcon"} />
                              </span>
                              <h5 style={{ color: 'rgb(208, 0, 0)', fontWeight: 'bold', fontSize: '12px', margin: 0 }}>
                                {processingFees}
                              </h5>
                          </div>
                          )}
                    </div> 
                    </Grid>
                  </Grid> </div>}
                 
                 {showCardForm && <EmiCreditCardDetails secret={apiData.secret}  bankId = {selectBankCode} displayOrderNo = {apiData.displayOrderNo} selectEmiCode = {selectEmiCode} bankList = {bankList} handleCloseDialog={handleCloseDialog}/>}
                </CustomTabPanel>
              );
            }
            if (base === 'EMI_DC') {
              return (
                <CustomTabPanel key={base} value={value} index={idx}>
              {showBanks && <div>  <div className='card-info'>
                    <ul>
                    {DCcodeList && DCcodeList.includes("21") && (
                 <li className={selectDCBankCode === '21' ? 'active' : ''} onClick={() => setDCBankCode('21')}>
                        <Link>
                          <img src="./images/hdfc.svg" alt="hdfc" /> <span>HDFC</span>
                        </Link>
                      </li>
                      )}
                       {DCcodeList && DCcodeList.includes("22") && (
                 <li className={selectDCBankCode === '22' ? 'active' : ''} onClick={() => setDCBankCode('22')}>
 
                        <Link>
                          <img src="./images/icici.svg" alt="icici" /> <span>ICICI</span>
                        </Link>
                      </li>
                      )}
                       {DCcodeList && DCcodeList.includes("48") && (
                 <li className={selectDCBankCode === '48' ? 'active' : ''} onClick={() => setDCBankCode('48')}>
 
                        <Link>
                          <img src="./images/sbi.svg" alt="SBi" /> <span>SBI</span>
                        </Link>
                      </li>
                      )}
                       {DCcodeList && DCcodeList.includes("32") && (
                 <li className={selectDCBankCode === '32' ? 'active' : ''} onClick={() => setDCBankCode('32')}>
 
                        <Link>
                          <img src="./images/kotak_mahindra.svg" alt="Kotak Mahindra" /> <span>Kotak Mahindra</span>
                        </Link>
                      </li>
                      )}
                       {DCcodeList && DCcodeList.includes("39") && (
                 <li className={selectDCBankCode === '39' ? 'active' : ''} onClick={() => setDCBankCode('39')}>
 
                        <Link>
                          <img src="./images/PNB.svg" alt="PNB" /> <span>Punjab National Bank</span>
                        </Link>
                      </li>
                      )}
                       {DCcodeList && DCcodeList.includes("6") && (
                 <li className={selectDCBankCode === '6' ? 'active' : ''} onClick={() => setDCBankCode('6')}>
 
                        <Link>
                          <img src="./images/BOB.svg" alt="hdfc" /> <span>Bank of Baroda</span>
                        </Link>
                      </li>
                      )}   
                      </ul>
                  </div>
                  <Grid container spacing={3}>
                    <Grid item md={12} xs={12} >
                      <FormControl fullWidth className='form-control'>
                        <InputLabel id="demo-simple-select-label">Select another bank</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={selectDCBankCode}
                          label="Bank Name"
                          onChange={DCEMIhandleChange}
                        >
                        {DCbankList && DCbankList.map((bank, index) => (
                        <MenuItem key={index} value={bank.code}>
                        {bank.name}
                         </MenuItem>
                         ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    {showEmiTable &&  <EmiTable  amountToBePaid={apiData.amount} displayOrderNo = {apiData.displayOrderNo}  mode = {mode} bankId = {selectDCBankCode}           			   onBankCodeSelect={handleBankCodeSelection} selectEmiCode = {selectEmiCode} onProcessingFees={setProcessingFees} />}
                     {NBerror && (
        <p style={{ color: 'red', paddingTop: '10px', marginLeft: '27px' }}>
          Please select valid bank and tenure!
        </p>
      )}		
                  
                    <Grid item md={12} xs={12}>
                      <Button variant="outlined" size="large" className='pay-now-btn' onClick={handleDCBankSelect}>
                        Continue 
                      </Button>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    {processingFees && processingFees.trim() !== '' && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                              <span>
                                <ImageComponents name={"notesIcon"} />
                              </span>
                              <h5 style={{ color: 'rgb(208, 0, 0)', fontWeight: 'bold', fontSize: '12px', margin: 0 }}>
                                {processingFees}
                              </h5>
                          </div>
                          )}
                    </div> 
                    </Grid>
                  </Grid></div>}
                 {showDCCardForm && <EmiDebitCardDetails secret={apiData.secret}  bankId = {selectDCBankCode} displayOrderNo = {apiData.displayOrderNo} selectEmiCode = {selectEmiCode} DCbankList = {DCbankList} handleDCCloseDialog={handleDCCloseDialog} amount = {apiData.amount}/>}
                </CustomTabPanel>
              );
            }
            if (base === 'EMI_CARDLESS') {
              return (
                <CustomTabPanel key={base} value={value} index={idx}>
                  <CardlessEmiDetails cardlessBankList={cardlessBankList} mode = {cardlessMode} secret = {apiData.secret} amountToBePaid = {apiData.amount}/>
                </CustomTabPanel>
              );
            }
            return null;
          })}
        </Box>
      </div>
    </div>
    </>
  );
}
